// Angular imports
import { Component, OnInit, OnDestroy } from '@angular/core';

// Import services
import { MessageService, MessageType } from '../../../services/message.service';

// Import types
import { CalculationMetaApi } from '../../../types/calculation';

// Import rxjs
import { BehaviorSubject, Subject, combineLatest, distinctUntilChanged, map, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state-management/app-state';
import * as CalculationActions from 'src/app/state-management/calculation-actions';
import { selectCalculationMeta, selectMaxVersion } from 'src/app/state-management/calculation-selectors';

export interface Version {
    id: number,
    description: string,
    date: Date
}

@Component({
    selector: 'version-dropdown',
    templateUrl: './version-dropdown.component.html',
    styleUrls: ['./version-dropdown.component.scss'],
    standalone: false
})
export class VersionDropdownComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject<void>();
    public calculationMeta$ = new BehaviorSubject<CalculationMetaApi>(null);
    public loaded$ = this.calculationMeta$.pipe(
        takeUntil(this.unsubscribe$),
        map(meta => !!meta),
        distinctUntilChanged()
    );

    // public _calculation: Calculation;
    public _versions: Version[] = [];
    public _selectedVersionId: number = 0;
    public _maxVersion: number = 0;
    public _open: boolean = false;


    constructor(
        // private applicationDataService: ApplicationDataService, 
        // private loaderService: LoaderService, 
        private messageService: MessageService,
        private store: Store<AppState>
    ) {

    }

    public ngOnInit() {
        combineLatest([
            this.store.select(selectCalculationMeta),
            this.store.select(selectMaxVersion)
        ]).pipe(
            takeUntil(this.unsubscribe$),
        ).subscribe(([meta, maxVersion]) => {
            this._maxVersion = maxVersion;

            if (meta) {
                const versions: Version[] = [];
                // Create versions
                for (let i = 1; i <= this._maxVersion; i++) {
                    versions.push({ id: i, description: `Versie ${i}`, date: new Date(meta.versionDate) });
                }
                // Sort
                versions.sort((a, b) => b.id - a.id);

                this._versions = versions;
                this._selectedVersionId = Math.max(versions.findIndex(v => v.id === meta.currentVersion), 0);
            }

            // Set the new meta
            this.calculationMeta$.next(meta);
        })
    }

    public ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    /* --- Event handlers --- */

    public _handleClickVersion(index: number) {
        if (index === this._selectedVersionId) return; // Ignore selection of the currently selected version

        // Set the selected version
        this._selectedVersionId = index;

        // Close dropdown
        this._open = false;

        // console.log('SELECT', this._calculation.versions[index]);
        this.store.dispatch(CalculationActions.loadCalculation({
            projectId: this.calculationMeta$.value.projectId,
            calculationId: this.calculationMeta$.value.id,
            version: this._versions[index]?.id
        }))

        // Change version
        // this.loaderService.performAsyncTask(async () => {
        //     await this.applicationDataService.setVersion(this._calculation.versions[index]);
        // });
    }

    /**
     * 
     */
    public _handleClickCopyToNewVersion() {
        this.messageService.show({
            title: 'Let op',
            message: 'Je kopieert nu deze calculatie naar een nieuwe versie. De huidige versie wordt daarmee bevroren en deze wordt de actieve. Wil je doorgaan?',
            type: MessageType.Info,
            buttons: [
                {
                    text: 'Kopieer',
                    handler: async () => {
                        // Freeze version
                        this.store.dispatch(CalculationActions.freezeCalculation({
                            projectId: this.calculationMeta$.value.projectId,
                            calculationId: this.calculationMeta$.value.id,
                            version: this._versions[this._selectedVersionId]?.id
                        }))
                        // this.loaderService.performAsyncTask(async () => await this.applicationDataService.copyVersion(this._calculation.versions[this._selectedVersionId]));
                    }
                },
                {
                    text: 'Nee'
                }
            ]
        });


    }
}
